export default __webpack_public_path__ + "static/media/2390.778d02b9.png";